import {
  Home,
  Package,
  ShoppingCart,
  Heart,
  Grid2x2,
} from "lucide-react";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useUserCart from "@/hooks/useUserCart";

type NavItem = {
  icon: React.ReactNode;
  activeIcon: React.ReactNode;
  label: string;
  path: string;
  showBadge?: boolean;
  badgeCount?: number;
};

export const MobileNavbar = () => {
  const [activeItem, setActiveItem] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const { cart } = useUserCart();
  const cartItemCount = Array.isArray(cart) && cart?.map((item)=> item.total_items)
  const count = Number(cartItemCount)
  const navItems: NavItem[] = [
    {
      icon: <Home className="w-5 h-5" strokeWidth={3} />,
      activeIcon: <Home className="w-5 h-5 fill-current" />,
      label: "Home",
      path: "/",
    },
    {
      icon: <Grid2x2 className="w-5 h-5" strokeWidth={3} />,
      activeIcon: <Grid2x2 className="w-5 h-5 stroke-[3]" />,
      label: "category",
      path: "/products",
    },

    {
      icon: <ShoppingCart className="w-5 h-5" strokeWidth={3} />,
      activeIcon: <ShoppingCart className="w-5 h-5 fill-current" />,
      label: "Cart",
      path: "/cart",
      showBadge: true,
      badgeCount: 3,
    },
    {
      icon: <Heart className="w-5 h-5" strokeWidth={3} />,
      activeIcon: <Heart className="w-5 h-5 fill-current" />,
      label: "Wishlist",
      path: "/wishlist",
    },

    {
      icon: <Package className="w-5 h-5" strokeWidth={3} />,
      activeIcon: <Package className="w-5 h-5 stroke-[3]" />,
      label: "Orders",
      path: "/orders",
    },
  ];
  const activeIndex = navItems.findIndex(
    (item) => item.path === location.pathname
  );

  return (
    <nav className="fixed md:hidden bottom-0 left-0 right-0 bg-white/90 backdrop-blur-sm border-t border-gray-200 shadow-lg z-50 safe-pb">
      <div className="flex justify-around items-center font-bold px-2 py-3">
        {navItems.map((item, index) => (
          <button
            type="button"
            key={item.path}
            onClick={() => navigate(item.path)}
            className={`flex flex-col items-center justify-center w-full relative transition-colors duration-200 ${
              activeIndex === index ? "text-yellow-700" : "text-gray-800"
            }`}
          >
            {activeIndex === index && (
              <div className="absolute -top-3 w-12 h-1 bg-yellow-700 rounded-full" />
            )}
            <div className="relative p-2 rounded-full font-bold transition-all duration-300 hover:bg-primary/10">
              {activeIndex === index ? item.activeIcon : item.icon}
              {item.showBadge && count > 0 && (
                <div className="absolute -top-1 -right-1 bg-yellow-600 text-white text-[10px] rounded-full w-4 h-4 flex items-center justify-center">
                  {count > 9 ? "9+" : count}
                </div>
              )}
            </div>
            <span className="text-xs mt-1 font-bold">{item.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};
